// extracted by mini-css-extract-plugin
export var fullWidthButton = "_dr-0";